import Vue from 'vue';
import Vuex from 'vuex';

import clothes from '@/assets/data/clothes';
import estate from '@/assets/data/estate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mode: document.location.hash !== '' ? 'estate' : 'clothes',
    content: {
      clothes,
      estate,
    },
    contact: false,
    pointer: 'default',
    loaded: false,
  },
  mutations: {
    SET_MODE: (state, mode) => { state.mode = mode; },
    SWITCH_MODE: (state) => {
      state.mode = state.mode === 'clothes' ? 'estate' : 'clothes';
      if (state.mode === 'estate') document.location.hash = '#estate';
      else document.location.hash = '';
    },
    SET_CONTACT: (state, payload) => { state.contact = payload; },
    SET_POINTER: (state, payload) => { state.pointer = payload; },
    SET_LOADED: (state, payload) => { state.loaded = payload; },
  },
  actions: {
  },
  modules: {
  },
});
